export default __webpack_public_path__ + "static/ai-marketing-3--mobile-5aeee8da5356a89d70ac1957db36cfba.webp";